var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-map"},[_c('commentary',{ref:"commentaryRef",attrs:{"info":_vm.info,"show":_vm.show}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }